import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import VueResource from 'vue-resource'
import './plugins/element.js'
import VueStorage from 'vue-ls'
import { VueAxios } from './utils/request'

import './permission'

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
import infiniteScroll from "vue-infinite-scroll";
 Vue.use(infiniteScroll);

 // vue-ls options
 let storageOptions = {
  namespace: 'pro__', // key键前缀
  name: 'ls', // 命名Vue变量.[ls]或this.[$ls],
  storage: 'local' // 存储名称: session, local, memory
}

// 安装 axios Vue.$http and this.$http
Vue.use(VueAxios)
// Vue.use(VueResource)
Vue.use(VueStorage,storageOptions)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.prototype.$scrollTo = (x = 0, y = 0, type = 'smooth') => {
	window.scrollTo({
		top: x,
		left: y,
		behavior: type // 滚动行为：smooth平滑滚动，instant瞬间滚动，默认值auto，等同于instant
	})
}

router.beforeEach((to, from, next) => {    
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})
